import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import { Link } from 'react-router-dom';
import ArrowLeft from 'material-ui/svg-icons/navigation/chevron-left';
import './NavSmall.css'

export default class NavSmall extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  handleTouchTap = (event) => {
    // This prevents ghost click.
    event.preventDefault();

    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  };

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  };

  render() {
    return (
      <div>
        <RaisedButton 
          onTouchTap={this.handleTouchTap}
          label="Menu"
          className="Menu"
        />
        <Popover
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{horizontal: 'right', vertical: 'top'}}
          targetOrigin={{horizontal: 'right', vertical: 'bottom'}}
          onRequestClose={this.handleRequestClose}
        >
          <Menu className="Menu">
            <MenuItem containerElement={<Link to="/" />} primaryText="Home" />
            <MenuItem 
        leftIcon={<ArrowLeft />}
        primaryText="Stuff"
         menuItems={[
                <MenuItem containerElement={<Link to="/links" />} primaryText="Links" />,
                <MenuItem containerElement={<Link to="/chat" />} primaryText="Chat" />
              ]}
        />
            <MenuItem containerElement={<Link to="/contact" />} primaryText="Contact" />
          </Menu>
        </Popover>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/NavSmall.js